import { observerAuth } from "./firebaseAuth";
import { observerBackendOrigin } from "./runtimeConfig";

export type ResearchTier = "free" | "plus" | "pro";

export interface ResearchItem {
  id: string;
  entityId: string;
  publicId: string;
  displayName: string;
  note?: string;
  collection: string;
  createdAt: string;
  updatedAt: string;
}

export interface ResearchLibrary {
  tier: ResearchTier;
  freeLimit: number;
  items: ResearchItem[];
}

async function authenticatedRequest(path: string, init?: RequestInit) {
  const user = observerAuth().currentUser;
  if (!user) throw new Error("Sign in to use your private Library.");
  const response = await fetch(`${observerBackendOrigin}${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${await user.getIdToken()}`,
      "Content-Type": "application/json",
      ...(init?.headers || {}),
    },
  });
  if (response.status === 204) return null;
  const payload = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new Error(payload.error || "Your private Library could not be updated.");
  return payload;
}

export async function loadResearchLibrary(): Promise<ResearchLibrary> {
  return authenticatedRequest("/api/observer/account/library") as Promise<ResearchLibrary>;
}

export async function saveResearchItem(
  entityId: string,
  note = "",
  collection = "Saved",
) {
  return authenticatedRequest(
    `/api/observer/account/library/${encodeURIComponent(entityId)}`,
    {
      method: "PUT",
      body: JSON.stringify({ note, collection }),
    },
  );
}

export async function deleteResearchItem(entityId: string) {
  await authenticatedRequest(
    `/api/observer/account/library/${encodeURIComponent(entityId)}`,
    { method: "DELETE" },
  );
}
